import React from "react";
import * as R from "ramda";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Alert, Spin } from "antd";
import { TaskComponents } from "../page/HumanTask/TaskComponents";
import { withApolloState } from "../util";

const ProcessSummaryQuery = gql`
    query ProcessSummaryQuery($processId: ID!) {
        process(id: $processId) {
            id
            artifacts(name: "conclusion", first: 1) {
                edges {
                    node {
                        id
                        createdDate
                        data
                    }
                }
            }
        }
    }
`;

const noop = () => {};

const getComponentName = (value: { "@type": string }) => {
    return value["@type"].split(".").pop();
};

const EmptySummary = () => (
    <Alert
        message="No process summary"
        description="There is currently no summary for this process."
        type="info"
    />
);

const ProcessSummary = ({
    processId,
    showUploader = true,
}: {
    processId: string;
    showUploader: Boolean;
}) => {
    return (
        <Query
            query={ProcessSummaryQuery}
            variables={{
                processId: btoa("Process:" + processId),
            }}
        >
            {withApolloState(
                ({ data }) => {
                    const result = R.path(
                        ["artifacts", "edges", 0, "node", "data"],
                        data.process
                    );

                    if (!result || typeof result !== "string") {
                        return <EmptySummary />;
                    }

                    const parsedData = JSON.parse(result);
                    const componentName = getComponentName(parsedData);
                    if (!componentName || !TaskComponents[componentName]) {
                        return <EmptySummary />;
                    }
                    const LoadableComponent = TaskComponents[componentName];

                    return (
                        <React.Suspense fallback={<div>Loading...</div>}>
                            <LoadableComponent
                                taskInput={{
                                    process_summary: parsedData,
                                    read_only: true,
                                    show_file_upload: showUploader,
                                }}
                                processId={processId}
                                onComplete={noop}
                            />
                        </React.Suspense>
                    );
                },
                () => (
                    <Spin tip="Loading..." />
                ),
                error => {
                    throw error;
                }
            )}
        </Query>
    );
};

export default ProcessSummary;
